import {TaskBookingInfo} from "../../../../../api/api";
import {PeopleIcon} from "../../../../../assets/icons/PeopleIcon";
import Tooltip from "@mui/material/Tooltip";
import styled from "styled-components";

export const BookingCount = ({bookingInfo}: { bookingInfo?: TaskBookingInfo }) => {
    if(!bookingInfo?.numberOfTechsBookedOnTaskToday){ return null; }
    if(bookingInfo?.numberOfTechsBookedOnTaskToday < 2){ return null; }
    return <Tooltip title={
        <>
            <p>{bookingInfo?.technicalResponsible?.name}</p>
            { bookingInfo?.otherBookedTechsToday?.map(p => <p>{p.name}</p>) }
        </>
    } >
        <RowCentered>
            <b style={{fontSize: '17px'}}>{bookingInfo.numberOfTechsBookedOnTaskToday}</b>
            <PeopleIcon size="25px"></PeopleIcon>
        </RowCentered>
    </Tooltip>
};

const RowCentered = styled.div`
  display: flex;
  column-gap: 2px;
  align-items: center;
  text-align: start;
`;